import React, { useState, useRef, useEffect } from "react";
import { gtmData2 } from "./data";
import "../assests/CSS/GTMComponent2.css";


const GTMComponent2 = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const contentRefs = useRef([]);

  const toggleDropdown = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    contentRefs.current.forEach((ref, i) => {
      if (ref) {
        if (activeIndex === i) {
          ref.style.maxHeight = ref.scrollHeight + "px";
        } else {
          ref.style.maxHeight = "0px";
        }
      }
    });
  }, [activeIndex]);

  return (
    <div className="gtm2-container">
      <h2 className="gtm2-title">What’s Inside the Toolkit?</h2>

      <div className="gtm2-dropdowns">
        {gtmData2.map((item, index) => (
          <div
            key={index}
            className={`gtm2-dropdown-card ${
              activeIndex === index ? "active" : ""
            }`}
          >
            {/* Header */}
            <div
              className="gtm2-dropdown-header"
              onClick={() => toggleDropdown(index)}
            >
              <span className="gtm2-check-icon">✔</span>
              <span className="gtm2-dropdown-title">{item.title}</span>
              <span
                className={`gtm2-arrow ${
                  activeIndex === index ? "rotate" : ""
                }`}
              >
                ▼
              </span>
            </div>

         
            <div
              ref={(el) => (contentRefs.current[index] = el)}
              className="gtm2-dropdown-wrapper"
            >
              <p className="gtm2-dropdown-content">{item.description}</p>
            </div>
          </div>
        ))}
      </div>

      <button className="gtm2-start-btn">Get Started</button>
    </div>
  );
};

export default GTMComponent2;
